<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('quotation.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('quotation.pageTitle'),
          href: '/admin/quotations'
        },
        {
          text: $t('create'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <form class="form-horizontal">
            <div class="ts-border ts-p-3 ts-rounded ts-shadow">
              <div class="row">
                <div class="col-md-6 ts-space-y-3">
                  <div class="row">
                    <label class="col-md-3 col-form-label required">{{
                      $t('quotation.date')
                    }}</label>
                    <div class="col-md-6">
                      <a-date-picker v-model="model.quotation_date" format="DD-MM-YYYY" valueFormat="DD-MM-YYYY"
                        class="ts-w-full"></a-date-picker>
                      <div class="validate" v-if="errors.has('quotation_date')">
                        {{ errors.first('quotation_date') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-3 col-form-label required">{{
                      $t('quotation.customer')
                    }}</label>
                    <div class="col-md-6">
                      <a-select v-model="model.customer_id" :filterOption="(input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                        " showSearch :options="customerList" class="ts-w-full" @change="customerChange"></a-select>
                      <div class="validate" v-if="errors.has('customer_id')">
                        {{ errors.first('customer_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-3 col-form-label">{{
                      $t('quotation.creditTerm')
                    }}</label>
                    <div class="col-md-6">
                      <input v-model.trim="model.credit_term" type="text" class="form-control" />
                      <div class="validate" v-if="errors.has('credit_term')">
                        {{ errors.first('credit_term') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-3 col-form-label">{{
                      $t('quotation.validUntil')
                    }}</label>
                    <div class="col-md-6">
                      <a-date-picker v-model="model.valid_until" format="DD-MM-YYYY" valueFormat="DD-MM-YYYY"
                        class="ts-w-full"></a-date-picker>
                      <div class="validate" v-if="errors.has('valid_until')">
                        {{ errors.first('valid_until') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 ts-space-y-3">
                  <div class="row">
                    <label class="col-md-3 col-form-label">{{
                      $t('quotation.projectName')
                    }}</label>
                    <div class="col-md-6">
                      <input v-model.trim="model.project_name" type="text" class="form-control" />
                      <div class="validate" v-if="errors.has('project_name')">
                        {{ errors.first('project_name') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-3 col-form-label required">{{
                      $t('quotation.pic')
                    }}</label>
                    <div class="col-md-6">
                      <input v-model.trim="model.pic" type="text" class="form-control" />
                      <div class="validate" v-if="errors.has('pic')">
                        {{ errors.first('pic') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-3 col-form-label">{{
                      $t('Remark')
                    }}</label>
                    <div class="col-md-6">
                      <textarea v-model="model.remarks" rows="5" class="form-control"
                        :class="{ 'is-invalid': errors.has('remarks') }"></textarea>
                      <div class="invalid-feedback" v-if="errors.has('remarks')">
                        {{ errors.first('remarks') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-12">
                <Detail ref="detail" v-model="model" :validate="errors" class="ts-shadow-inner ts-p-3 ts-rounded" />
              </div>
            </div>
            <div class="row ts-mt-4">
              <div class="col-md-12 ts-flex ts-justify-end ts-space-x-2">
                <ts-button @click.prevent="$router.push({ name: 'quotation' })">{{ $t('cancel') }}</ts-button>
                <ts-button :waiting="waiting" @click.prevent="saveAddNew" color="primary" outline>{{ $t('savePrint')
                }}</ts-button>
                <ts-button :waiting="waiting_save" @click.prevent="save" color="primary">{{ $t('save') }}</ts-button>
              </div>
            </div>
          </form>
        </ts-loading-banner>
        <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
          <ts-preview-pdf v-model="waiting" :src="src" />
        </a-modal>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import Detail from './components/item-detail'
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  name: 'quotationCreate',
  components: {
    Detail
  },
  data() {
    return {
      waiting: false,
      waiting_save: false,
      loading: false,
      show_pdf: false,
      errors: new Errors(),
      src: null,
      model: {
        quotation_date: moment().format('DD-MM-YYYY'),
        project_name: null,
        pic: null,
        customer_id: null,
        grand_total: null,
        vat_rate: null,
        vat_amount: null,
        total_exclude_vat: null,
        credit_term: null,
        valid_until: null,
        discount_rate: 0,
        discount_type: '%',
        item_list: [],
        sub_total: 0,
        remarks: null
      }
    }
  },
  created() {
    this.model.vat_rate = parseFloat(
      this.$store.state.authUser.sys_setting.vat_rate
    )
    this.loading = true
    this.fetchResource().finally(() => (this.loading = false))
  },
  computed: {
    ...mapState('wholesale/quotation', ['customers']),
    ...mapGetters('wholesale/quotation', ['getCreditDay']),
    customerList() {
      return this.customers.map(el => ({
        value: el.customer_id,
        label: el.customer_name
      }))
    }
  },
  methods: {
    ...mapActions('wholesale/quotation', ['fetchResource', 'store']),
    saveAddNew() {
      this.waiting = true
      this.show_pdf = true
      this.errors = new Errors()
      this.$refs.detail.calculate()
      this.store(this.model)
        .then(response => {
          this.src = response.url
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.show_pdf = false
        })
        .finally(() => {
          this.waiting = false
        })
    },
    save() {
      this.waiting_save = true
      this.errors = new Errors()
      this.$refs.detail.calculate()
      this.store(this.model)
        .then(response => {
          this.$router.push({ name: 'quotation' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_save = false
        })
    },
    customerChange(value, option) {
      this.model.credit_term = this.getCreditDay(value)
    },
    clearInput() {
      this.model.quotation_date = moment().format('DD-MM-YYYY')
      this.model.project_name = null
      this.model.pic = null
      this.model.customer_id = null
      this.model.grand_total = null
      this.model.vat_amount = null
      this.model.credit_term = null
      this.model.valid_until = null
      this.model.total_exclude_vat = null
      this.model.item_list = []
      this.errors = new Errors()
      this.model.remarks = null
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('wholesale/quotation/CLEAR_SETUP')
    next()
  }
}
</script>
